<template>
  <div class="form-progress-wrap edit-profile academic-info-wrap">
    <div class="container">
      <div class="steps-content">
        <div class="general-form-wrap academic-info-wrap box-wrapper">
          <div class="academic-form-wrap">
            <FormModel
              layout="horizontal"
              :form="form"
              @submit="handleSubmit"
              :model="resource"
              ref="form"
            >
              <div class="academic-info">
                <div class="heading">
                  <h2 class="form-title">Academic Information</h2>
                </div>
                <a-row :gutter="32">
                  <a-col :sm="8">
                    <BaseFormInput
                      name="highSchool"
                      placeholder="Enter school name"
                      label="School Name"
                      :value="resource.highSchool"
                      @change="
                        event =>
                          handleFormItemChange('highSchool', event.target.value)
                      "
                    />
                  </a-col>
                  <a-col :sm="8">
                    <BaseFormInput
                      name="gpa"
                      placeholder="(0 - 4)"
                      label="GPA"
                      :minValue="0"
                      :maxValue="5"
                      :value="resource.gpa"
                      @change="
                        event => handleFormItemChange('gpa', event.target.value)
                      "
                    />
                  </a-col>
                  <a-col :sm="8">
                    <BaseFormInput
                      name="satScore"
                      placeholder="(0 - 1600)"
                      type="number"
                      :minValue="0"
                      :maxValue="1200"
                      label="SAT score"
                      :value="resource.satScore"
                      @change="
                        event =>
                          handleFormItemChange('satScore', event.target.value)
                      "
                    />
                  </a-col>
                  <a-col :sm="8">
                    <BaseFormInput
                      name="actScaleScore"
                      placeholder="(0 - 36)"
                      type="number"
                      :minValue="0"
                      :maxValue="1600"
                      label="ACT score"
                      :value="resource.actScaleScore"
                      @change="
                        event =>
                          handleFormItemChange(
                            'actScaleScore',
                            event.target.value
                          )
                      "
                    />
                  </a-col>
                </a-row>
              </div>
              <div class="majors-info">
                <div class="heading">
                  <h2 class="form-title">Likely Majors</h2>
                </div>
                <a-row :gutter="32">
                  <a-col :sm="8">
                    <BaseFormInput
                      name="major1"
                      placeholder="Major 1"
                      :value="resource.major1"
                      @change="
                        event =>
                          handleFormItemChange('major1', event.target.value)
                      "
                    />
                  </a-col>
                  <a-col :sm="8">
                    <BaseFormInput
                      name="major2"
                      placeholder="Major 2"
                      :value="resource.major2"
                      @change="
                        event =>
                          handleFormItemChange('major2', event.target.value)
                      "
                    />
                  </a-col>
                  <a-col :sm="8">
                    <BaseFormInput
                      name="major3"
                      placeholder="Major 3"
                      :value="resource.major3"
                      @change="
                        event =>
                          handleFormItemChange('major3', event.target.value)
                      "
                    />
                  </a-col>
                </a-row>
              </div>
              <a-form-item>
                <a-button
                  type="primary"
                  html-type="submit"
                  class="next-button first-button"
                  >Save and Continue</a-button
                >
                <a-button
                  type="primary"
                  @click="handleStepSkip"
                  class="next-button second-button"
                  >Skip</a-button
                >
              </a-form-item>
            </FormModel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Athlete } from "@/models";
import { FormModel } from "ant-design-vue";
const STORE_KEY = "athleteStore";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export default {
  name: "AcademicInfo",
  props: ["id"],
  data() {
    return {
      hasErrors,
      form: this.$form.createForm(this),
      resource: new Athlete({})
    };
  },
  components: {
    FormModel
  },
  mounted() {
    this.dispatcher();
  },
  computed: {
    ...mapGetters({
      ProfileData: `${STORE_KEY}/getViewProfileData`,
      athlete: `${STORE_KEY}/athlete`,
      athleteLoading: `${STORE_KEY}/athleteLoading`
    }),
    athleteId() {
      return this.id || this.$route.params.id || sessionStorage["profile-id"];
    }
  },
  methods: {
    validateForm() {
      return true;
    },
    handleFormItemChange(key, value) {
      this.resource = new Athlete({ ...this.resource, [key]: value });
    },
    async dispatcher() {
      await this.$store.dispatch(`${STORE_KEY}/getAthlete`, {
        id: this.athleteId
      });
    },
    ...mapActions({
      setPlayerDetailInfo: `${STORE_KEY}/setPlayerDetailInfo`
    }),
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },
    handleStepSkip() {
      this.$emit("save", 3);
    },

    // Submit value
    async handleSubmit(e) {
      e.preventDefault();
      this.$refs.form.validate(async valid => {
        if (valid) {
          const params = {
            registerPageCompleted:
              Number(this.resource.registerPageCompleted) < 3
                ? 3
                : this.resource.registerPageCompleted,
            id: this.athleteId,
            highSchool: this.resource.highSchool,
            gpa: this.resource.gpa,
            satScore: this.resource.satScore,
            actScaleScore: this.resource.actScaleScore,
            majors: [
              this.resource.major1,
              this.resource.major2,
              this.resource.major3
            ],
            slug: "athlete",
            message: "Academic Information Added to Profile"
          };

          await this.$store.dispatch(`${STORE_KEY}/updateAthlete`, params);
          await this.$store.dispatch(`${STORE_KEY}/getAthlete`, {
            id: this.athleteId
          });
          this.$emit("save", this.athlete.registerPageCompleted);
        }
      });
    }
  },
  watch: {
    athlete(newVal, _) {
      this.resource = new Athlete(newVal);
    },
    "resource.satScore": {
      deep: true,
      immediate: true,
      handler: function(newVal) {
        if (newVal < 0 || newVal > 1600) {
          this.resource.satScore = 0;
        }
      }
    },
    "resource.actScaleScore": {
      deep: true,
      immediate: true,
      handler: function(newVal) {
        if (newVal < 0 || newVal > 36) {
          this.resource.actScaleScore = 0;
        }
      }
    }
  }
};
</script>
<style lang="scss">
.academic-info-wrap {
  .ant-input-number {
    width: 100%;
  }
  .first-button {
    margin-right: 2rem;
  }
  .second-button {
    width: 200px;
  }
}
</style>
